/**
 * 가격 관련 상수 정의
 */
/**
 * 기본 가격 소수점 자리수
 * pointUnit이나 pipUnit이 없거나 유효하지 않을 때 사용되는 기본값
 */
export const DEFAULT_PRICE_DECIMAL_PLACES = 5;
//# sourceMappingURL=price.js.map